import React from "react";
import { Card, CardBody } from "reactstrap";
import PropTypes from "prop-types";

const StatsCard = ({ icon, title = "Total", count, subText = "Total", styles = {} }) => {
    const { card, body, iconClass, titleClass, countClass, subTextClass } = styles;

    return (
        <Card className={`stats-card ${card}`}>
            <CardBody className={`stats-card-body ${body}`}>
                <img src={icon} alt="icon" className={`icon ${iconClass}`} />
                <div className={`title ${titleClass}`}>{title}</div>
                <div className={`subtext ${subTextClass}`}>{subText}</div>
                <div className={`count ${countClass}`}>{count}</div>
            </CardBody>
        </Card>
    );
};

StatsCard.propTypes = {
    icon: PropTypes.node.isRequired,
    title: PropTypes.string,
    count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    subText: PropTypes.string,
    styles: PropTypes.shape({
        card: PropTypes.string,
        body: PropTypes.string,
        iconClass: PropTypes.string,
        titleClass: PropTypes.string,
        countClass: PropTypes.string,
        subTextClass: PropTypes.string
    })
};

export default StatsCard;
